export default "__VITE_ASSET__BsDLCop2__"